export interface MonthNames {
  full: string[]
  short: string[]
}

/**
 * Month labels for the active locale via Intl (12 entries, index = month 0–11).
 *
 * :param locale: BCP 47 locale; defaults to the runtime default when omitted
 * :return: Full and abbreviated month name arrays
 */
export function getMonthNames(locale?: string): MonthNames {
  const full: string[] = []
  const short: string[] = []
  for (let month = 0; month < 12; month++) {
    const anchor = new Date(2024, month, 1)
    full.push(new Intl.DateTimeFormat(locale, { month: 'long' }).format(anchor))
    short.push(new Intl.DateTimeFormat(locale, { month: 'short' }).format(anchor))
  }
  return { full, short }
}
